import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b2cff51"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pb-1" }
const _hoisted_2 = { class: "flex items-center border p-1 px-4 border-primary-50 dark:border-dark-400 dark:bg-dark-500" }
const _hoisted_3 = { class: "mr-2 text-gray-600 dark:text-dark-text" }
const _hoisted_4 = { class: "my-2 border rounded bg-white dark:border-dark-400 dark:bg-dark-400" }
const _hoisted_5 = { class: "flex mt-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1))
const _hoisted_7 = { class: "my-2 text-gray-900 dark:text-dark-text" }
const _hoisted_8 = { class: "text-lg" }
const _hoisted_9 = { class: "font-bold ml-4" }
const _hoisted_10 = { class: "flex items-center mt-2 text-xs text-gray-500 dark:text-dark-text" }
const _hoisted_11 = { class: "mr-2" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "material-icons mr-4" }
const _hoisted_14 = {
  key: 0,
  class: "text-course dark:text-course-dark"
}
const _hoisted_15 = {
  key: 1,
  class: "text-gray-500 dark:text-dark-text"
}
const _hoisted_16 = { class: "text-lg font-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_progress_bar = _resolveComponent("base-progress-bar")!
  const _component_DropDown = _resolveComponent("DropDown")!
  const _component_CourseHeatMap = _resolveComponent("CourseHeatMap")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.calc2digit(_ctx.problemSearchModalStatePresenter.selectedCourse.value.progress)) + "% ", 1),
      _createVNode(_component_base_progress_bar, {
        num: _ctx.calc2digit(_ctx.problemSearchModalStatePresenter.selectedCourse.value.progress)
      }, null, 8, ["num"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_DropDown, {
          class: "mr-3",
          itemList: _ctx.items,
          selected: _ctx.changeProgramLanguage,
          selectedIndex: _ctx.nested.selectedIndex.value
        }, null, 8, ["itemList", "selected", "selectedIndex"])
      ]),
      _createVNode(_component_CourseHeatMap, {
        class: "pb-2 mx-4",
        course: _ctx.problemSearchModalStatePresenter.selectedCourse.value,
        height: "400",
        programLanguage: _ctx.selectedProgramLanguage,
        user: _ctx.user
      }, null, 8, ["course", "programLanguage", "user"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.problemSearchModalStatePresenter.selectedCourse.value.topics, (topic) => {
        return (_openBlock(), _createElementBlock("details", {
          key: topic.id,
          class: "my-1"
        }, [
          _createElementVNode("summary", {
            class: _normalizeClass(["hover-hand py-3 pr-4 pl-12 border rounded relative hover:shadow transition-shadow duration-100 hover:border-course dark:border-dark-400 dark:text-dark-text dark:bg-dark-500 dark:hover:border-course-dark", _ctx.isLightMode() ? 'arrow' : 'arrow-dark'])
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", null, _toDisplayString(topic.shortName), 1),
              _createElementVNode("span", _hoisted_9, _toDisplayString(topic.name), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.calc2digit(topic.progress)) + "%", 1),
              _createVNode(_component_base_progress_bar, {
                num: topic.progress
              }, null, 8, ["num"])
            ])
          ], 2),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topic.problems, (problem) => {
            return (_openBlock(), _createElementBlock("div", {
              key: problem.id,
              class: "hover-hand border rounded my-1 flex items-center p-4 hover:shadow transition duration-100 hover:border-course dark:border-dark-400 dark:text-dark-text dark:bg-dark-500 dark:hover:border-course-dark",
              onClick: () => _ctx.clickProblem(problem.id)
            }, [
              _createElementVNode("span", _hoisted_13, [
                (problem.isSolved)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, " check_circle "))
                  : (_openBlock(), _createElementBlock("span", _hoisted_15, " radio_button_unchecked "))
              ]),
              _createElementVNode("p", _hoisted_16, _toDisplayString(problem.id) + " : " + _toDisplayString(problem.name), 1)
            ], 8, _hoisted_12))
          }), 128))
        ]))
      }), 128))
    ])
  ]))
}